export default "__VITE_ASSET__DOtye2OH__"